module.exports = __webpack_public_path__ + "static/media/playstation.ac66de07.png";